export default __webpack_public_path__ + "static/media/rocket-cartoon-min.c653b92a.png";